import Search from "../assets/images/search.svg"
import Calculate from "../assets/images/calculate.png"
import Line from "../assets/images/line.png"
import Bin from "../assets/images/bin.png"
import Polygon from "../assets/images/polygon.png"
import Home from "../assets/images/home.png"
import Tree from "../assets/images/tree.png"
import UK_FLAG from "../assets/images/flag_us_uk.svg"
import GR_FLAG from "../assets/images/flag_gr.png"
import FR_FLAG from "../assets/images/flag_fr.png"
import Close from "../assets/images/close.svg"
import ArrowUp from "../assets/images/arrow_up.svg"
import ArrowDown from "../assets/images/arrow_down.svg"
import Exit from "../assets/images/exit.png"
import Plus from "../assets/images/plus.svg"
import Minus from "../assets/images/minus.svg"
import Panorame from "../assets/images/panorame.svg"
import Fire from "../assets/images/fire.png"

export const IMAGES = {
  SEARCH: Search,
  CALCULATE: Calculate,
  LINE: Line,
  BIN: Bin,
  POLYGON: Polygon,
  HOME: Home,
  TREE: Tree,
  UK_FLAG: UK_FLAG,
  GR_FLAG: GR_FLAG,
  FR_FLAG: FR_FLAG,
  CLOSE: Close,
  ARROW_UP: ArrowUp,
  ARROW_DOWN: ArrowDown,
  EXIT: Exit,
  PLUS: Plus,
  MINUS: Minus,
  PANORAME: Panorame,
  FIRE: Fire,
}